import CounterData from "./CounterData"

const VacuumData = () => (
    <CounterData counterType='vacuum'/>
)

export default VacuumData